import { get } from 'sortablejs'
import { createAPI } from '../../common'

export default {

    //保存评选设置
    postFlowSave: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0gmpx0tbwf', 'post', config),
    //新建评选管理
    postSelectionSave: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0tbwf', 'post', config),
    //评选管理详情
    getDetail: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0efubjm', 'get', config),
    //获取评选设置
    getFlow: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0hfu0gmpx', 'get', config),
    //评选发布
    postPublish: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0qvcmjti', 'post', config),
    //评选归档
    postArchive: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0bsdijwf', 'post', config),
    //评选删除
    postDelete: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0efmfuf', 'Delete', config),
    //获取信息表单设置
    getFields: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0gjfmet', 'get', config),
    //新建保存作品
    postWorkSave: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0xpslt0tbwf', 'post', config),
    //作品详情
    getWorkDetail: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0xpslt0efubjm', 'get', config),
    //作品删除
    delWork: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0xpslt0efmfuf', 'Delete', config),
    //作品评审详情
    getReviewDetail: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0xpslt0sfwjfx0efubjm', 'get', config),
    //作品评审保存
    postReviewSave: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0xpslt0sfwjfx', 'post', config),
    //作品分数计算
    postScore: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0xpslt0tdpsf', 'post', config),
    //作品下载
    getDownload: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0xpslt0epxompbe', 'get', config),
    //获取稿签设置
    getLabelRange: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0hfuMbcfmSbohf', 'get', config),
    //获取稿签列表
    getLabelList: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0hfuEpnMbcfm', 'get', config),
    //保存作品设置
    postWorkSetting: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0xpslt0tfuujoht', 'post', config),
    //作品选用（签发）
    postWorkChoose: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0tfmfdujpo0xpslt0dipptf', 'post', config),
    //评审明细
    getSelctionReviewDetail: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0xpslt0sfwjfxEfubjm', 'get', config),
    //复制链接
    getCopyLink: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0tfmfdujpo0dpqzMjol', 'get', config)

}
